<template>
    <v-navigation-drawer v-model="drawer" v-if="drawer" location="right" temporary>
        <template v-slot:prepend>
            <v-list-item two-line>
                <v-list-item-title class="text-center"
                    >{{ currentUser.firstname }} {{ currentUser.lastname }}</v-list-item-title
                >
                <v-list-item-subtitle class="text-center">{{
                    currentUser.company.name
                }}</v-list-item-subtitle>
                <v-list-item-subtitle class="text-center">{{
                    currentUser.email ? currentUser.email.split("#")[0] : "XXX"
                }}</v-list-item-subtitle>
            </v-list-item>
        </template>

        <v-divider></v-divider>

        <v-list>
            <v-list-item ripple>
                <v-list-item-title
                    @click.stop="onPasswordChangeClick"
                    class="text-decoration-underline"
                    style="cursor: pointer"
                    >Changer de mot de passe</v-list-item-title
                >
            </v-list-item>
        </v-list>

        <template v-slot:append>
            <v-row no-gutters>
                <v-col cols="12" class="d-flex justify-end px-2">
                    <img :src="bobbee_hrz" height="25px" />
                </v-col>
                <v-col cols="12" class="pa-2">
                    <v-btn
                        block
                        elevation="0"
                        class="rounded-lg gradient error mt-2"
                        large
                        @click="logout"
                        data-cy="index-logout"
                        >Se déconnecter</v-btn
                    >
                </v-col>
            </v-row>
        </template>
    </v-navigation-drawer>
</template>
<script lang="ts">
import { Component, Vue, toNative, Prop, Model } from "vue-facing-decorator";
import { User } from "@/store/store";

import bobbee_hrz from "@/assets/img/bobbee_hrz.png";
import { logOutUser } from "@/services/userServices";

@Component({
    emits: ["afterLogout", "passwordChangeClick"],
})
class MobileNavigationDrawer extends Vue {
    @Model({ required: true, type: Boolean }) drawer!: boolean;
    @Prop({ required: true, default: null, type: User }) currentUser!: User;

    get bobbee_hrz() {
        return bobbee_hrz;
    }

    async logout() {
        // this.$store.commit("logoutUser");
        await logOutUser(this.$store, this.$router);
        this.$emit("afterLogout");
    }

    onPasswordChangeClick() {
        this.$emit("passwordChangeClick");
    }
}

export default toNative(MobileNavigationDrawer);
</script>
